import React from 'react';
interface ProgressRingProps {
  percent: number;
  size?: number;
  strokeWidth?: number;
  /** Renders light-on-dark for use inside the dark report header. */
  onDark?: boolean;
}
export function ProgressRing({
  percent,
  size = 56,
  strokeWidth = 5,
  onDark = false
}: ProgressRingProps) {
  const radius = (size - strokeWidth) / 2;
  const circumference = 2 * Math.PI * radius;
  const clamped = Math.max(0, Math.min(100, percent));
  const offset = circumference - clamped / 100 * circumference;
  const complete = clamped === 100;
  return <span className="relative inline-flex flex-shrink-0 items-center justify-center" style={{
    width: size,
    height: size
  }} role="img" aria-label={`${clamped} procent færdig`} data-id="element-671" data-mp="2ejyp19l4tagl">
      <svg width={size} height={size} className="-rotate-90" data-id="element-672" data-mp="24onaosdmy59d">
        <circle cx={size / 2} cy={size / 2} r={radius} fill="none" strokeWidth={strokeWidth} className={onDark ? 'stroke-white/20' : 'stroke-stone-200'} data-id="element-673" data-mp="o7j2a7uakxpn" />
        <circle cx={size / 2} cy={size / 2} r={radius} fill="none" strokeWidth={strokeWidth} strokeLinecap="round" strokeDasharray={circumference} strokeDashoffset={offset} className={complete ? 'stroke-emerald-500' : onDark ? 'stroke-emerald-400' : 'stroke-brand-500'} style={{
        transition: 'stroke-dashoffset 260ms cubic-bezier(0.23, 1, 0.32, 1)'
      }} data-id="element-674" data-mp="3737xfymof52w" />
      </svg>
      <span className={`absolute text-xs font-bold ${onDark ? 'text-white' : 'text-stone-900'}`} data-id="element-675" data-mp="2ngat6ru9iqk">
        {clamped}%
      </span>
    </span>;
}